import React from 'react';
import './svg.css';

const UploadDataIcon = () => {
  return (

    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.3425 15.0375V17.225C19.3425 18.4331 18.3632 19.4125 17.155 19.4125H4.90503C3.69691 19.4125 2.71753 18.4331 2.71753 17.225V15.0375" stroke="#282828" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.03 16.7875V6.28748" stroke="#282828" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.8738 9.34998L11.03 6.28748L8.18628 9.34998" stroke="#333333" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}

export default UploadDataIcon;